import React, { useEffect, useState } from "react";
import classes from "./Banner2.module.scss";
import CustomImage from "../../CustomImage";
import { Card } from "react-bootstrap";
import useIsMobile from "../../../hooks/useIsMobile";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";
import Banner from "../Banner/Banner";

function chunkArray(array: any[], size: number) {
  const chunks: any[][] = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
}

const Banner2 = ({ countryData }: { countryData: any }) => {
  const isMobile = useIsMobile(900);
  const bannerData = countryData?.banner_2 ?? {};

  const [chunkedFeatureIcons, setChunkedFeatureIcons] = useState<any>([]);

  useEffect(() => {
    let tempChunkedFeatureIcons = chunkArray(bannerData?.icons ?? [], isMobile ? 3 : 4);
    setChunkedFeatureIcons(tempChunkedFeatureIcons ?? []);
  }, [bannerData]);

  return (
    <Banner bannerData={bannerData ?? {}} bgInverted={true} bannerStyles={isMobile ? {} : { width: "calc(100vw - 425px - 90px)" }}>
      <div className={classes["banner-container"]}>
        <h2 className={classes["partner-banner-title"]}>{bannerData.title ?? ""}</h2>

        <div className={classes["features-container"]}>
          {Array(3)
            .fill(0)
            .map((el: any, index: number) => (
              <div className={classes["feature-item"]}>
                <div className={classes["feature-item-icon"]}>
                  <CustomImage src="/icons/star_icon.svg" height={16} width={16} alt={"banner-feature-icon"} />
                </div>
                <p className={classes["feature-item-title"]}>{bannerData[`feature_${index + 1}_title`]}</p>
              </div>
            ))}

          {isMobile && (
            <div className={classes["feature-icons-container-wrapper"]}>
              <div className={classes["feature-icons-container-mobile"]}>
                {chunkedFeatureIcons.map((row: any, rowIndex: number) => (
                  <div key={rowIndex} className={`${classes["feature-icons-row"]} ${classes[`feature-icons-row-${rowIndex}`]}`}>
                    {row.map((elChild: any) => (
                      <Card key={elChild.id} className={classes["feature-card"]}>
                        <div className={classes["feature-icon-item"]}>
                          <CustomImage
                            src={elChild?.url ?? "/icons/placeholder-image.svg"}
                            height={"39px"}
                            width={"118px"}
                            objectFit="cover"
                            alt={"banner-feature-icon"}
                          />
                        </div>
                      </Card>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}

          <button className={`${classes["appointment-button"]} ${isFrappeOrJotFormClass(bannerData?.enquireForm?.url)}`}>
            {bannerData.btnLabel ?? "Fix an Appointment"}
          </button>
        </div>

        {!isMobile && (
          <div className={classes["feature-icons-container"]}>
            {chunkedFeatureIcons.map((row: any, rowIndex: number) => (
              <div key={rowIndex} className={`${classes["feature-icons-row"]} ${classes[`feature-icons-row-${rowIndex}`]}`}>
                {row.map((elChild: any) => (
                  <Card key={elChild.id} className={classes["feature-card"]}>
                    <div className={classes["feature-icon-item"]}>
                      <CustomImage
                        src={elChild?.url ?? "/icons/placeholder-image.svg"}
                        height={"39px"}
                        width={"118px"}
                        objectFit="cover"
                        alt={"banner-feature-icon"}
                      />
                    </div>
                  </Card>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </Banner>
  );
};

export default Banner2;
